
// 详情页的默认配置
export default {
  canvasType: 'canvas', // 画布类型 canvas， excel
  canvasName: '模板', // 画布名字
  // 中间的配置列表(默认一个空数据)
  configList: [],
  activeConfig: 0,
  isShow: true, // 画布是否启用
  // 左边的数据源
  dataSource: {
    appid: '', // 本表id
    appidName: '',  // 本表名
    formList: [],
    //  appid:[传参条件]

    field: {}
  },
}

// 自由画布和固定画布独有的配置
export const canvasDefaultConfig = {
  navType: 0, // 0 进度 1步骤
  isRequired: false, // 必填完成后才能翻页
  isCompleteFlip: false, // 填完表之后自动翻页
}

// 表格模式的配置
export const excelDefaultConfig = {
  previewMode: [0, 1], // 预览模式
  tonBtnList: ['print', 'toPdf', 'toImg', 'toWord'], // 头部显示的按钮
  isNewBorder: true, //
  watermark: { // 水印设置
    user: false,
    time: false,
    status: false,
    custom: {
      value: false,
      text: ''
    },
  },
  isFlow: false,
  dataSourceShowType: 'pagination', // 主表数据源类型 pagination singlePage
  pageHeaderSet: {
    pageHeader: {
      left: [],
      center: [],
      right: []
    },
    pageFooter: {
      left: [],
      center: [],
      right: []
    }
  }, // 页眉页脚设置
  activeExcel: 0,  // 当前显示表格
  // 表格数据(插件)
  sheetList: [],
  sheetConfig: {}, // 表格配置（自己平台）
}

export const pageDefaultConfig = {
  A4:{width: 210, height: 297},
  A5:{width: 148, height: 210},
  B3:{width: 353, height: 500},
  B4:{width: 250, height: 353},
  B5:{width: 176, height: 250}
}
// 表格的配置
export const sheetConfig = {
  isGrid: true, // 是否显示网格
  showType: 'singlePage', // 显示类型 continuation singlePage
  pageDirection: 'portrait',  // 纸张方向 portrait 纵向,  landscape 横向 默认纵向
  pageType: 'A4', // 纸张大小 A4 A5 B3 B4 B5 custom自定义
  excelWidth: 210,
  excelHeight: 297,
  pageTop: 20,
  pageBottom: 20,
  pageLeft: 17,
  pageRight: 17,
  backgroundValue: 0, // 背景默认为纯色
  backgroundColor: 'rgba(255, 255, 255, 1)', // 默认颜色为灰色不透明
  backgroundImage: '', // 背景图片
  percentage: 100, // 背景默认透明度
  backgroundSize: 'cover', // 背景显示 'cover' 'auto' 默认铺满
  expandList: [], // expandType 拓展方式,  checkedRange 组块的范围, repeatTitle // 重复标题  dataSource // 组块的数据源
}

// 表格默认配置
export const sheetDefaultConfig = {
  activeExcel: "Sheet_5aozCe3iWKW7_1695103859611",
  previewMode:0,
  canvasName:"模板1",
  canvasType:"excel",
  sheetConfig: {
    Sheet_5aozCe3iWKW7_1695103859611: {
      backgroundColor:"rgba(255, 255, 255, 1)",
      backgroundImage:"",
      backgroundSize:"cover",
      backgroundValue:0,
      excelHeight:297,
      excelWidth:210,
      isGrid:true,
      pageBottom:20,
      pageDirection:"portrait",
      pageLeft:17,
      pageRight:17,
      pageTop:20,
      pageType:"A4",
      percentage:100,
      showType:"singlePage",
    }
  }
}
// 画布配置
export const canvasConfig = {
  isGrid: true, // 是否显示网格
  gridSize: 20, // 网格尺寸
  canvasWidth: 1200, // 画布宽度
  canvasHeight: 1000, // 画布高度
  backgroundValue: 0, // 背景默认为纯色
  backgroundColor: 'rgba(245,248,250,1)', // 默认颜色为灰色不透明
  backgroundImage: '', // 背景图片
  percentage: 100, // 背景默认透明度
  shadow: true, // 画布投影 默认开启的
  navInfo: {
    // 导航配置
    nextText: '下一页',
    prevText: '上一页',
    stepText: '步骤',
  }
}

// 固定画布配置
export const fixedCanvasConfig = {
  fixedCanvasSize: {
    // 画布尺寸、其实就是弹窗的尺寸
    width: {
      type: 'screen',
      value: 50,
    },
    height: {
      type: 'auto',
    },
  },
  fixedCanvasAppid: null, // 固定画布使用的数据源
  // fixedCanvasFiledLayout: 1, // 固定画布的字段布局 1 上下 0 左右
}
// 单个点的配置
export const single = {
  w: 1180,
  isShow: true, // 默认是否显示
  isAutoHeight: true, // 是否自适应高度
  differHeight: 0, // 内容自适应后增加的高度
  maxHeight: 0, // 最大高度，为0时根据内容自适应
  exceedType: 0, // 超出最大高度时的显示方式 0,裁剪 1,滚动 2,收起展开
  Layout: 0, // 字段布局默认为左右
  isShowKey: 0, // 字段名称默认为显示
  isShowBorder: 0, // 值边框默认为显示
  isDisabled: false, // 字段是否锁定
  // datatype: 1, // 1 应用 2 工坊 5仪表盘 区分单个控件的数据源类型
  keyWidth: 120, // 字段名的宽度
  keyMinWidth: 50, // 字段名的最小宽度
  backgroundColor: '#FFFFFF', // 控件背景色
  contentOutside: 0, // 内容超出 0 滚动 1截断
  condition: {
    ov: 'and',
    isAppen: 'appen',
    linked: []
  },
  // 字段的字体设置
  fontKey:{
    fontSetValue: '雅黑', // 字体设置
    fontSizeValue: 14, // 字号设置
    fontColorValue: '#000000', // 字体颜色
    fontXAlignValue: 'flex-end', // 水平对齐
    fontYAlignValue: 'center', // 垂直对齐
    fontisBold: false, // 字体加粗
    fontisItalics: false, // 斜体
    fontisUnderline: false, // 下划线
  },
  // 值的字体设置
  fontValue:{
    fontSetValue: '雅黑', // 字体设置
    fontSizeValue: 14, // 字号设置
    fontColorValue: '#000000', // 字体颜色
    fontXAlignValue: 'flex-start', // 水平对齐
    fontYAlignValue: 'center', // 垂直对齐
    fontisBold: false, // 字体加粗
    fontisItalics: false, // 斜体
    fontisUnderline: false, // 下划线
  },
}
// 图片控件专属的配置
export const imgConfig = {
  showStyle: 0, // 图片显示的样式 0, 是默认的 1是新增的
  rows: 1, // 显示行数
  rowNum: 4 // 每行图片数
}
// 联系人控件专属的配置
export const userConfig = {
  userKey: 'realname'
}
// 颜色标签配置
export const colorTagConfig = {
  filedTagInfo: {
    isColorTag: false,
    colorType: '1',
    list: []
  }
}
// 可配置颜色标签的控件
export const isColorTagType = ['text', 'number', 'radio', 'checkbox', 'textarea']
// 高度基准配置
export const heightObj = {
  textarea: 120,
  image: 100,
  file: 120,
  label: 44,
  richTextWid: 120,
  'ready-widget': 120,
  'new-rel-radio': 120,
  details: 120,
  text: 37  // 其他的为 37
}

// 追加的按钮初始化配置
export const buttonConfig = {
  w: 220,
  h: 40,
  x: 125,
  y: 410,
  list: []
}

// 图标基础配置
export const customizeIcon = {
  y: 0,
  x: 10,
  w: 50,
  h: 50,
  url: '',
  type: 'customizeIcon',
  name: '图标',
  isShow: true,
  isDisabled: false, // 字段是否锁定
}
// 图片基础配置
export const customizeImg = {
  y: 0,
  x: 10,
  w: 50,
  h: 50,
  url: '',
  type: 'customizeImg',
  name: '图片',
  isShow: true,
  isDisabled: false, // 字段是否锁定
}
// 文本基础配置
export const customizeTxt = {
  y: 0,
  x: 10,
  w: 100,
  h: 37,
  text: '请输入文本',
  type: 'customizeTxt',
  name: '文本',
  isShow: true,
  isDisabled: false, // 字段是否锁定
  backgroundColor: '#FFFFFF', // 背景色
  fontKey: {
    fontSetValue: '雅黑', // 字体设置
    fontSizeValue: 14, // 字号设置
    fontColorValue: '#000000', // 字体颜色
    fontXAlignValue: 'flex-start', // 水平对齐
    fontYAlignValue: 'flex-start', // 垂直对齐
    fontisBold: false, // 字体加粗
    fontisItalics: false, // 斜体
    fontisUnderline: false, // 下划线
  }
}

// 按钮基础配置
export const customizeButton = {
  y: 0,
  x: 10,
  w: 100,
  h: 37,
  type: 'customizeButton',
  name: '按钮',
  info: {
    // 按钮样式
    buttonStyle: 'one',
    // 选中的绑定功能
    bindingFunction: '',
    // 选中的尺寸
    size: 'small',
    // 选中的图标
    icon: 1,
    // 按钮文本
    text: ''
  },
  isShow: true,
  isDisabled: false, // 字段是否锁定
}

